class VariantSelectorDropdown extends HTMLElement {
    constructor() {
        super();
        this.selectButton = this.querySelector('.select-button');
        this.optionsDropdown = this.querySelector('.options-dropdown');
        this.selectedOptionDisplay = this.querySelector('.select-button');
    }

    connectedCallback() {
        const options = this.querySelectorAll('.option-button');

        options.forEach(option => {
            option.addEventListener('click', () => this.selectOption(option));
        });

        this.selectButton.addEventListener('click', () => this.toggleDropdown());

        document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) {
                this.classList.remove('active');
            }
        });
    }

    toggleDropdown() {
        this.classList.toggle('active');
    }

    selectOption(button) {
        const selectedValue = button.getAttribute('data-option-value');
        this.selectedOptionDisplay.querySelector('.select-button-text').textContent = selectedValue;

        this.optionsDropdown.querySelectorAll('.option-button').forEach(btn => {
            btn.classList.remove('selected');
        });

        button.classList.add('selected');

        this.classList.remove('active');
    }
}

customElements.define('variant-selector-dropdown', VariantSelectorDropdown);